import styled from 'styled-components';
import { Text } from '@medly-components/core';

export const LegendContainer = styled.div`
    display: flex;
    align-items: center;
    &:last-child {
        span {
            padding-right: 0 !important;
        }
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: 100%;
    }
`;

export const LegendText = styled(Text)`
    color: ${({ theme }) => theme.colors.darkBlue};
`;
